import TtamPlacementBlockListSwitch from './switch/index.vue';
import TtamPlacementBlockListSwitchTips from './switch-tips/index.vue';
import TtamPlacementBlockListBlockAppInfo from './block-app-info/index.vue';
import * as hooks from './hooks';

export default {
  TtamPlacementBlockListSwitch,
  TtamPlacementBlockListSwitchTips,
  TtamPlacementBlockListBlockAppInfo,
  ...hooks,
};
